import React from 'react';
import { Box, Text, Wrap, WrapItem, Tag } from '@chakra-ui/react';

const TemplateKeyInsert = ({ keys, onInsert }) => {
  return (
    <Box mb={4}>
      <Text fontSize='xs' color='gray.500' mb={1}>
        Insert key:
      </Text>
      <Wrap spacing={1}>
        {keys.map((key) => (
          <WrapItem key={key}>
            <Tag
              size='sm'
              variant='outline'
              colorScheme='blue'
              cursor='pointer'
              _hover={{ bg: 'blue.50' }}
              onClick={() => onInsert(key)}
            >
              {key}
            </Tag>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
};

export default TemplateKeyInsert;
